import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.4 19.4v-4.8h2V13h-2V8.2h2V6.6h-2V1.8H7v4.8H5v1.6h2v1.6h3.2V8.2h5.6V13h-5.6v-1.6H7V13H5v1.6h2v4.8ZM3 17.8h2.4v-1.6H3Zm0-6.4h2.4V9.8H3Zm8.8 0h2.4V9.8h-2.4ZM3 5h2.4V3.4H3Zh1.6Zh.8",
      "transform-origin": "center"
    }, null, -1),
    _createElementVNode("path", { d: "M18 6a2.5 2.5 0 0 1-5 0c0-1.38 2.5-4.5 2.5-4.5S18 4.62 18 6z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "NetDiagramColoring"}) } }